<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M10.102 8.03572H2.25v7.02548h7.852V8.03572ZM6.17604 13.3699c1.02708 0 1.85969-.8326 1.85969-1.8597s-.83261-1.8597-1.85969-1.8597c-1.02708 0-1.85969.8326-1.85969 1.8597s.83261 1.8597 1.85969 1.8597Z"
            clip-rule="evenodd"
        />
        <path
            d="M2.66327 15.4745h1.2398v5.9923c0 .3424-.27754.6199-.6199.6199s-.6199-.2775-.6199-.6199v-5.9923Zm5.78571 0h1.2398v5.9923c0 .3424-.27754.6199-.6199.6199s-.6199-.2775-.6199-.6199v-5.9923Z"
        />
        <path
            d="M3.48979 16.7143h5.78572v1.2398H3.48979v-1.2398Zm0 2.4796h5.78572v1.2398H3.48979v-1.2398ZM6.38266 3.43718l2.89285-.90402L5.96938 1.5l.00002 3.12925L1.125 7.5H11.25L6.38266 4.61565V3.43718Z"
        />
        <path
            fill-rule="evenodd"
            d="M10.9152 14.95h-.3999v-2.7816h.3999c1.0594 0 2.0739.4116 2.8129 1.1415l6.1853 6.1081c.1945.1921.4615.3004.7403.3004h.4555c.7681 0 1.3908.6227 1.3908 1.3908S21.8773 22.5 21.1092 22.5h-.4555c-1.0594 0-2.0739-.4117-2.8129-1.1415l-6.1853-6.1081c-.1945-.1921-.4615-.3004-.7403-.3004Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M1.29797 5.71008c0-.48.33003-.86998.78003-.97998L6.99792 3l4.87998 1.72009c.47.08.8301.48999.8301.98999 0 .45-.3001.82996-.7101.95996v2.45008c1.5 0 2.8801.84995 3.5401 2.19998L18.448 17h1.5499c1.1 0 2 .9 2 2v3h-4.78c-1.52 0-2.91-.74-3.58-2.1l-2.64-5.2999V21c0 .55-.46 1-.99998 1-.55 0-1-.45-1-1v-.8799h-4V21c0 .55-.46 1-1 1-.55 0-1-.45-1-1v-6.8799h-1V6.66003c-.41-.13-.69995-.50995-.69995-.94995ZM8.99792 18.1201v-1h-4v1h4Zm2.99998-7v1L15.428 19.01c.34.68 1.0299 1.1101 1.7899 1.1101h2.78V19H18.448c-.45 0-.8901-.1499-1.2301-.4199-.15-.11-.2699-.24-.3899-.39-.06-.09-.11-.1901-.17-.2901l-2.9001-5.6899c-.01-.03-.0299-.06-.0499-.09-.14-.23-.31-.4301-.52-.5901-.34-.26-.7501-.4099-1.1901-.4099Zm-1.99998 1V6.18005l-3-1.05993-3 1.05993v5.94005h6Zm-1-2.99998c0 1.10998-.91 1.99998-2 1.99998-1.11 0-2-.89-2-1.99998 0-1.1.89-2 2-2 1.09 0 2 .9 2 2Zm-4 4.99998v1h4v-1h-4Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
